// ==============================|| THEME & APP CONSTANTS ||============================== //

export const APP_DEFAULT_PATH = '/reef-dashboard';
export const DRAWER_WIDTH = 260;
export const MINI_DRAWER_WIDTH = 60;

/** Defaults merged with session storage (`reef-dashboard-config`). */
const config = {
  /** Ant Design palette key for primary brand color (see `THEME_PRESETS` in themeColors.js). */
  presetColor: 'blue',
  fontFamily: `'Public Sans', sans-serif`,
  /** Main content width: full-bleed vs centered container. */
  layout: 'fluid'
};

export default config;
